import { createFileRoute } from '@tanstack/react-router';
import { DebtsSettingsPage } from '@/features/settings/debts-settings-page.js';

export const Route = createFileRoute('/_app/settings/debts')({
  component: DebtsSettingsPage,
});
